import React, { Component } from 'react';
import moment from 'moment';

import WorkspaceTimePicker from './WorkspaceTimePicker';
import WorkspaceFilterDropDown from './WorkspaceFilterDropDown';

export default class WorkspaceLeftBar extends Component {

	constructor(props) {
		super(props);

		window.leftBar = this;

		this.state = {
			isScrollTop: true
		}

		this.generateFilters = this.generateFilters.bind(this);
		this.generateFiltersAlternativeWay = this.generateFiltersAlternativeWay.bind(this);
	}

	generateFilters() {
		let result = [];

		let filters = this.props.filters;

		let optionsJsxCount = 0;

		Object.keys(filters).forEach(key => {

			let f = filters[key];

			let optionsJsx = [];

			if (f.options.length > 0 && typeof f.options[0] === "object") {

				f.options.forEach(op => {

					let isExpanded = this.props.expandedFilterMajors.includes(op.value)
					let fillStateClass = "";
					if (op.selected.length === op.options.length) {
						fillStateClass = " selected"
					}

					optionsJsx.push((
						<div
							className={"option-major" + (isExpanded ? " expanded" : "") + (op.selected.length > 0 ? " selected" : "")}
						>
							<div className={"material-icons drop-down"} onClick={this.props.expandFilterMajor.bind(null, op.value)}>{"chevron_right"}</div>
							<div className={"checkbox"} onClick={this.props.makeFilterMajorSelection.bind(null, op.value, key)}>
								<div className={"material-icons check"}>{op.selected.length > 0 && op.selected.length != op.options.length ? "remove" : "check"}</div>
							</div>
							<div className={"option-label"}>{`${op.label} (${op.selected.length}/${op.options.length})`}</div>
						</div>
					));

					optionsJsxCount++;
					if (isExpanded) {
						optionsJsxCount += op.options.length;
					}

					op.options.forEach(sub => {
						optionsJsx.push((
							<div
								className={"option-simple indented" + (f.selected.includes(sub) ? " selected" : "") + (isExpanded ? "" : " hidden")}
								onClick={this.props.makeFilterSelection.bind(null, sub, key)}
							>
								<div className={"checkbox"}>
									<div className={"material-icons check"}>{"check"}</div>
								</div>
								<div className={"option-label"}>
									{f.map != null && f.map != undefined &&
										this.props.allMaps[f.map] != undefined && this.props.allMaps[f.map][sub] != undefined ? this.props.allMaps[f.map][sub] : sub}
								</div>
							</div>
						));
					})
				});

			} else {
				let useMap = f.map != null && f.map != undefined &&
					this.props.allMaps[f.map] != undefined;

				_.sortBy(f.options, op => (useMap && this.props.allMaps[f.map][op] != undefined ? this.props.allMaps[f.map][op] : op).toString().toUpperCase()).forEach(op => {
					optionsJsxCount++;
					optionsJsx.push((
						<div
							className={"option-simple" + (f.selected.includes(op) ? " selected" : "")}
							onClick={this.props.makeFilterSelection.bind(null, op, key)}
						>
							<div className={"checkbox"}>
								<div className={"material-icons check"}>{"check"}</div>
							</div>
							<div className={"option-label"}>
								{useMap && this.props.allMaps[f.map][op] != undefined ? this.props.allMaps[f.map][op] : op}
							</div>
						</div>
					));
				});
			}

			let denominator = f.options.length;
			if (f.options.length > 0 && typeof f.options[0] === "object") {
				denominator = 0;
				f.options.forEach(op => { denominator += op.options.length })
			}

			let optionsContainerStyle = {};
			if (this.props.activeFilter === key && optionsJsxCount < 6) {
				optionsContainerStyle.height = (optionsJsxCount * 3) + 'rem';
			}
			//TODO: test
			if (denominator > 0) {
				result.push((
					<div
						key={`left-nav-filter-${key}`}
						className={"filter-container" + (this.props.activeFilter === key ? " active" : "")}
					>
						<div className={"label"} onClick={this.props.setActiveFilter.bind(null, key)}>{`${f.label}`}<span>{` (${f.selected.length}/${denominator})`}</span></div>
						<div className={"material-icons drop-icon"} onClick={this.props.setActiveFilter.bind(null, key)}>{"arrow_drop_down"}</div>
						<div className={"options-container"} style={optionsContainerStyle}>
							{this.props.isOpen ? optionsJsx : null}
						</div>
						<div className={"off-clicker"} onClick={this.props.setActiveFilter.bind(null, null)}></div>
					</div>
				))
			}
		});

		result.push((
			<div className={"filter-spacer"}></div>
		))

		return result;
	}

	generateFiltersAlternativeWay() {

		let result = [];

		let filters = this.props.filters;

		Object.keys(filters).forEach(filter => {
			if(filter === 'onlineStoreId') {
				if(this.props.isOnlineStoreEnabled) {
					result.push(<WorkspaceFilterDropDown
						allMaps={this.props.allMaps}
						isOpen={this.props.isOpen}
						filterKey={filter} filter={filters[filter]}
						activeFilter={this.props.activeFilter}
						expandedFilterMajors={this.props.expandedFilterMajors}
						makeFilterSelection={this.props.makeFilterSelection}
						setActiveFilter={this.props.setActiveFilter}
						selectAllFilters={this.props.selectAllFilters}
						deSelectAllFilters={this.props.deSelectAllFilters}
						activeWorkspaceId={this.props.activeWorkspaceId}
					/>)
				}
			} else {
				result.push(<WorkspaceFilterDropDown
					allMaps={this.props.allMaps}
					isOpen={this.props.isOpen}
					filterKey={filter} filter={filters[filter]}
					activeFilter={this.props.activeFilter}
					expandedFilterMajors={this.props.expandedFilterMajors}
					makeFilterSelection={this.props.makeFilterSelection}
					setActiveFilter={this.props.setActiveFilter}
					selectAllFilters={this.props.selectAllFilters}
					deSelectAllFilters={this.props.deSelectAllFilters}
					activeWorkspaceId={this.props.activeWorkspaceId}
				/>)
			}
		});

		result.push((
			<div className={"filter-spacer"}></div>
		));

		return result;
	}

	handleScroll(e) {
		var activeScrollTop = e.target.scrollTop;
		this.setState({ isScrollTop: (activeScrollTop <= 0) });
	}

	render() {

		let todayDateIndexString = moment.utc().format("MM/DD/YYYY");

		let outerStyle = {};

		if (!this.state.isScrollTop) {
			outerStyle = { boxShadow: '0 9px 18px -9px rgba(34, 36, 40, 0.2)' };
		}

		return (
			<div className={`workspace-left-bar-outer ${this.props.isOpen ? 'open' : ''} ${this.props.timeOpen ? 'time-open' : ''}`}>
				<div className={"meta-section"}>
					<div className={this.props.isOpen ? 'filter-title' : 'dispNone'} onClick={() => this.props.resetFilters()}>
						<span className={'material-icons'}>refresh</span>
					</div>
					<div className={"material-icons drag-button"} onClick={this.props.setLeftBarOpen.bind(null, !this.props.isOpen)}>{"arrow_forward_ios"}</div>
				</div>
				<div className={"title"} style={outerStyle}>{`${true ? 'Dashboard' : 'Chart'} Filters`}</div>
				<div className={"filter-section"} onScroll={this.handleScroll.bind(this)}>
					{this.generateFiltersAlternativeWay()}
				</div>
				<div className={"time-section"}>
					<div className={"top"}>
						<div className={"date-display"}>
							<div className={"label"}>{"Start"}</div>
							<div className={"date"}>{dateIndexToDate(this.props.timeFilter.fromDate)}</div>
						</div>
						<div className={"calendar-button-container"}>
							<div className={"material-icons calendar-button"} onClick={this.props.setTimeOpen.bind(null, !this.props.timeOpen)}>{"event"}</div>
						</div>
						<div className={"date-display"}>
							<div className={"label"}>{"End"}</div>
							<div className={"date"}>{dateIndexToDate(this.props.timeFilter.toDate)}</div>
						</div>
					</div>
					<div className={"divider"}></div>
					<WorkspaceTimePicker
						isActive={this.props.timeOpen}
						timeFilter={this.props.timeFilter}
						calendarSpread={this.props.calendarSpread}

						setTimeOpen={this.props.setTimeOpen}
						setTimeRange={this.props.setTimeRange}
					/>

					<div className={"data-last-update-section"}>{this.props.dataLastUpdate === null ? '' : (todayDateIndexString === moment(this.props.dataLastUpdate + 'z').format("MM/DD/YYYY") ?
						'Data Refreshed today at ' + moment(this.props.dataLastUpdate + 'z').format("h:mm a") :
						'Data Refreshed on ' + moment(this.props.dataLastUpdate + 'z').format("MM/DD/YYYY h:mm a"))}
					</div>
				</div>
			</div>
		);
	}
}
